import { render, staticRenderFns } from "./sensibilityText.vue?vue&type=template&id=975fb816&scoped=true"
import script from "./sensibilityText.vue?vue&type=script&lang=js"
export * from "./sensibilityText.vue?vue&type=script&lang=js"
import style0 from "./sensibilityText.vue?vue&type=style&index=0&id=975fb816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975fb816",
  null
  
)

export default component.exports